import { render, staticRenderFns } from "./rightMenuItem.vue?vue&type=template&id=3ef0af54&scoped=true"
import script from "./rightMenuItem.vue?vue&type=script&lang=js"
export * from "./rightMenuItem.vue?vue&type=script&lang=js"
import style0 from "./rightMenuItem.vue?vue&type=style&index=0&id=3ef0af54&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef0af54",
  null
  
)

export default component.exports